import { connect } from 'react-redux';
import LaporanPengunjung from '../../../views/Library/LaporanPengunjung/LaporanPengunjung.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';
import { getPeriodsOptions } from '../../../states/thunks/options.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
    getPeriodsOptions: (payload) => dispatch(getPeriodsOptions(payload)),
  };
}

export default connect(null, mapDispatchToProps)(LaporanPengunjung);
